var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-picture"},[(_vm.imgs_list.length > 0)?_c('com-img-slider',{attrs:{"img-list":_vm.imgs_list}}):_vm._e(),_vm._t("user"),_vm._t("title"),_vm._t("content"),(_vm.game_card_list.length > 0)?_c('com-game-list',{attrs:{"game-card-list":_vm.game_card_list}}):_vm._e(),_vm._t("tag")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }